import { useMediaQuery } from '@vueuse/core';

// $vl-bp-small: 767px
export function useIsMobile(max_width = '767px') {
    return useMediaQuery(`(max-width: ${max_width})`);
}
